<div class="container">


  <span class="body2-impaired" >{{ 'VERSION_VISUALLY_IMPAIRED.ALL_RIGHT_RESERVED' | translate }}</span>
<span class="link3-impaired" [routerLink]="termsLink">{{'OTHER.TERMS_HEADER' | translate}}</span>
<div>
 <span class="body2-impaired"> {{'FOOTER.TECHNICAL_SUPPORT' | translate}}: </span>
  <a class="link3-impaired" href="mailto:opendata@mos.ru">opendata&#64;mos.ru</a>
</div>
</div>
